// import 'babel-polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'

import App from './App.vue'
import router from './router/index.js'
import './plugins/element.js'
// 导入全局样式表
import './assets/css/global.css'
// import enLocale from 'node_modules\element-ui\src\locale\lang'
// import enLocale from 'element-ui/lib/locale/lang/en'
import axios from 'axios'
import qs from 'qs'// axios参数包
import Print from 'vue-print-nb'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
// axios.defaults.baseURL = 'http://51.68.206.7:8081'
// axios.defaults.baseURL = 'https://www.myirequest.com:8081'
// axios.defaults.baseURL = 'http://myapi.demotesting.top'
axios.defaults.baseURL = 'https://www.myirequest.com:8081'
// axios.defaults.baseURL = 'http://122.51.4.230:8081'
// axios.defaults.baseURL = 'http://localhost:8081'
axios.interceptors.request.use(config => {
  console.log(config)
  config.headers.Authorization = window.sessionStorage.getItem('token')
  return config
})

// 声明一个调用方法
export const requestLogin = params => { return axios.post('/user/login', qs.stringify(params)).then(res => res.data) }

Vue.prototype.$http = axios

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

Vue.use(ElementUI, { locale })
Vue.use(Print) // 注册/
